import React from 'react';
import cross from '../../../assets/icons/simple_cross.svg';
interface Props {
  setOpenModal: any;
}
function FreightModal({ setOpenModal }: Props) {
  return (
    <div
      className='modal show'
      id='freight_class_modal'
      tabIndex={-1}
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5) ' }}
      role='dialog'
      aria-labelledby='freightClassModalLabel'
    >
      <div
        className='modal-dialog modal-dialog-centered modal-lg'
        role='document'
      >
        <div className='modal-content-freight'>
          <div className='modal-header-freight'>
            <h5 className='col-10 ubbe-black'>NMFC Freight Classification</h5>
            <img
              onClick={() => {
                setOpenModal(false);
              }}
              style={{ cursor: 'pointer' }}
              width={24}
              height={24}
              src={cross}
            />
          </div>
          <div className='modal-body p-0 m-4'>
            <div className='row'>
              <div className='col-12'>
                <label className='justify-text'>
                  When shipping LTL, all commodities are not created equal.
                  Different products will have different freight classes, and
                  your shipment’s freight class will have a significant impact
                  on your rate. In short, to get an accurate LTL quote, you need
                  an accurate freight class. The National Motor Freight
                  Classification determines this class using four
                  characteristics:{' '}
                  <span className='font-italic'>
                    Density (Weight Per Cubic FT), Stowability, Handling and
                    Liability.
                  </span>
                </label>
              </div>
            </div>

            <div className='row mt-4'>
              <div className='col-12'>
                <table
                  className='table table-striped'
                  id='packagesTable'
                  style={{ width: '100%' }}
                >
                  <thead>
                    <tr className='table-header'>
                      <th
                        style={{
                          width: '25%',
                          paddingLeft: '15px',
                          paddingBottom: '10px',
                        }}
                      >
                        Class
                      </th>
                      <th
                        style={{
                          width: '50%',
                          paddingLeft: '15px',
                          paddingBottom: '10px',
                        }}
                      >
                        Commodity Examples
                      </th>
                      <th
                        style={{
                          width: '25%',
                          paddingBottom: '10px',
                          paddingLeft: '15px',
                        }}
                      >
                        Density
                      </th>
                    </tr>
                  </thead>
                  <tbody id='rows'>
                    <tr>
                      <td>Class 50</td>
                      <td>
                        Nuts, bolts, steel rods, fits on standard shrink-wrapped
                        4X4 pallet, strapping material, flour
                      </td>
                      <td>50+ lbs</td>
                    </tr>
                    <tr>
                      <td>Class 55</td>
                      <td>
                        Bricks, cement, mortar, hardwood flooring, cloths or
                        rags, magazines, copy paper
                      </td>
                      <td>35-50 lbs</td>
                    </tr>
                    <tr>
                      <td>Class 60</td>
                      <td>
                        Car accessories & car parts, steel cables, used tires,
                        stone blocks, glass, moldings
                      </td>
                      <td>30-35 lbs</td>
                    </tr>
                    <tr>
                      <td>Class 65</td>
                      <td>
                        Car parts & accessories, bottled beverages, books in
                        boxes, conveyors, chocolate in boxes, electric cords,
                        tile
                      </td>
                      <td>22.5-30 lbs</td>
                    </tr>
                    <tr>
                      <td>Class 70</td>
                      <td>
                        Newspapers, wooden pencils, machinery, caskets,
                        unassembled furniture, food items, automobile engines,
                        boxed paper
                      </td>
                      <td>15-22.5 lbs</td>
                    </tr>
                    <tr>
                      <td>Class 77.5</td>
                      <td>
                        Tires, bathroom fixtures, garments, shirts/pants,
                        snowplows
                      </td>
                      <td>13.5-15 lbs</td>
                    </tr>
                    <tr>
                      <td>Class 85</td>
                      <td>
                        Crated machinery, transmissions, clutches, doors,
                        CDs/DVDs, motorcycle engine, cast iron stoves
                      </td>
                      <td>12-13.5 lbs</td>
                    </tr>
                    <tr>
                      <td>Class 92.5</td>
                      <td>
                        Computers, monitors, refrigerators and freezers,
                        gas-powered generators, cabinets, kiosk or ATMs
                      </td>
                      <td>10.5-12 lbs</td>
                    </tr>
                    <tr>
                      <td>Class 100</td>
                      <td>
                        Vacuum, boat & car covers, canvas, wine cases, caskets
                      </td>
                      <td>9-10.5 lbs</td>
                    </tr>
                    <tr>
                      <td>Class 110</td>
                      <td>
                        Cabinets, framed paintings & artwork, table saw,
                        metalworking
                      </td>
                      <td>8-9 lbs</td>
                    </tr>
                    <tr>
                      <td>Class 125</td>
                      <td>
                        Small household appliances, pictures/posters in boxes,
                        exhibit booths, vending machines
                      </td>
                      <td>7-8 lbs</td>
                    </tr>
                    <tr>
                      <td>Class 150</td>
                      <td>
                        ATV, jet skis, motorcycles, assembled wooden furniture,
                        work stations, Auto sheet metal, bookcases
                      </td>
                      <td>6-7 lbs</td>
                    </tr>
                    <tr>
                      <td>Class 175</td>
                      <td>
                        Clothing, couches, stuffed furniture, metal cabinets
                      </td>
                      <td>5-6 lbs</td>
                    </tr>
                    <tr>
                      <td>Class 200</td>
                      <td>
                        TVs, aircraft parts, aluminum table, packaged
                        mattresses, snowmobiles
                      </td>
                      <td>4-5 lbs</td>
                    </tr>
                    <tr>
                      <td>Class 250</td>
                      <td>
                        Bamboo furniture, engine hoods, mattresses and box
                        springs, unassembled couch, plasma TV
                      </td>
                      <td>3-4 lbs</td>
                    </tr>
                    <tr>
                      <td>Class 300</td>
                      <td>
                        Wood cabinets, tables, chairs, model boats,
                        kayaks/canoes, chassis
                      </td>
                      <td>2-3 lbs</td>
                    </tr>
                    <tr>
                      <td>Class 400</td>
                      <td>Deer antlers</td>
                      <td>1-2 lbs</td>
                    </tr>
                    <tr>
                      <td>Class 500</td>
                      <td>Bags of gold dust, ping pong balls</td>
                      <td>{`< 1 lbs`}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FreightModal;
